/* Many SETTINGS are stored in the localStorage by their name -
    be careful about changing the value of a SETTINGS constant, as doing so can invalidate existing SETTINGS */
export const CREDIT_REQUIRED_ACKNOWLEDGED = 'credit_required_acknowledged';
export const CRYPTO_DISCLAIMERS = 'crypto_disclaimers';
export const ARWEAVE_PAYMENTS_INFO_ACK = 'arweave_payments_info_ack';
export const NEW_USER_ACKNOWLEDGED = 'welcome_acknowledged';
export const EMAIL_COLLECTION_ACKNOWLEDGED = 'email_collection_acknowledged';
export const INVITE_ACKNOWLEDGED = 'invite_acknowledged';
export const LANGUAGE = 'language';
export const SHOW_MATURE = 'show_mature';
export const SHOW_ANONYMOUS = 'show_anonymous';
export const SHOW_UNAVAILABLE = 'show_unavailable';
export const INSTANT_PURCHASE_ENABLED = 'instant_purchase_enabled';
export const INSTANT_PURCHASE_MAX = 'instant_purchase_max';
export const THEME = 'theme';
export const THEMES = 'themes';
export const AUTOMATIC_DARK_MODE_ENABLED = 'automatic_dark_mode_enabled';
export const CLOCK_24H = 'clock_24h';
export const AUTOPLAY_MEDIA = 'autoplay';
export const AUTOPLAY_NEXT = 'autoplay_next';
export const OS_NOTIFICATIONS_ENABLED = 'os_notifications_enabled';
export const AUTO_DOWNLOAD = 'auto_download';
export const HIDE_BALANCE = 'hide_balance';
export const HIDE_SPLASH_ANIMATION = 'hide_splash_animation';
export const HIDE_TITLE_NOTIFICATION_COUNT = 'hide_title_notification_count';
export const FLOATING_PLAYER = 'floating_player';
export const DARK_MODE_TIMES = 'dark_mode_times';
export const ENABLE_SYNC = 'enable_sync';
export const TO_TRAY_WHEN_CLOSED = 'to_tray_when_closed';
export const ENABLE_PUBLISH_PREVIEW = 'enable-publish-preview';
export const DESKTOP_WINDOW_ZOOM = 'desktop_window_zoom';
export const SHOW_NSFW = 'showNsfw';
export const FIRST_RUN_STARTED = 'first_run_started';
export const FOLLOWING_ACKNOWLEDGED = 'following_acknowledged';
export const TAGS_ACKNOWLEDGED = 'tags_acknowledged';
export const REWARDS_ACKNOWLEDGED = 'rewards_acknowledged';
export const SEARCH_IN_LANGUAGE = 'search_in_language';
export const HOMEPAGE = 'homepage';
export const HOMEPAGE_ORDER = 'homepage_order';
export const HOMEPAGE_ORDER_APPLY_TO_SIDEBAR = 'homepage_order_apply_to_sidebar';
export const HIDE_MEMBERS_ONLY_CONTENT = 'hide_members_only_content';
export const HIDE_REPOSTS = 'hide_reposts';
export const HIDE_SHORTS = 'hide_shorts';
export const HIDE_LIVESTREAMS_IN_CATEGORIES = 'hide_livestreams_in_categories';
export const DEFAULT_COLLECTION_ACTION = 'default_collection_action';
export const HIDE_SCHEDULED_LIVESTREAMS = 'hide_scheduled_livestreams';
export const SUPPORT_OPTION = 'support_option';
export const TILE_LAYOUT = 'tile_layout';
export const VIDEO_THEATER_MODE = 'video_theater_mode';
export const VIDEO_PLAYBACK_RATE = 'video_playback_rate';
export const CHAPTERS_CARD_VISIBLE = 'chapters_card_visible';
export const PREFERRED_CURRENCY = 'preferred_currency';
export const DEFAULT_VIDEO_QUALITY = 'default_video_quality';
export const ACTIVE_CHANNEL_CLAIM = 'active_channel_claim';
export const UPLOAD_PAGE_FILTERING = 'upload_page_filtering';
export const AUTOPLAY_NEXT_SHORTS = 'autoplay_next_shorts';
export const SHORTS_ASPECT_RATIO_LTE = 0.8;
export const SHORTS_DURATION_LTE = 180;
export const DISABLE_SHORTS_VIEW = 'disable_shorts_view';
export const FYP_MODAL_SHOWN = 'fyp_modal_shown';
export const P2P_DELIVERY = 'p2p_delivery';
export const P2P_OPT_IN_DISMISSED = 'p2p_opt_in_dismissed';
export const ENABLE_BROWSER_STREAM = 'enable_browser_stream';
export const SETTINGS_GRP = {
  APPEARANCE: 'appearance',
  ACCOUNT: 'account',
  CONTENT: 'content',
  PLAYER: 'player',
  SYSTEM: 'system',
};
